<template>
  <div class="container d-flex flex-column p-4">
    <div class="row d-flex align-items-center">
      <div class="col-12 col-lg-6">
        <div class="container align-start">
          <BaseHeading heading="Homepage.title" classNames="bold white" :level=1></BaseHeading>
        </div>
        <HomePageButtons />
      </div>
      <div class="col-12 col-lg-6">
        <FaqAccordion />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseHeading from '@/components/base/BaseHeading.vue';
import FaqAccordion from '@/components/home/FaqAccordion.vue';
import HomePageButtons from '@/components/home/HomePageButtons.vue';


</script>

<style scoped lang="scss">
@import '@/styles/views/homeView';
</style>
